import { render, staticRenderFns } from "./editormenu.vue?vue&type=template&id=585b3fae&scoped=true"
import script from "./editormenu.vue?vue&type=script&lang=js"
export * from "./editormenu.vue?vue&type=script&lang=js"
import style0 from "./editormenu.vue?vue&type=style&index=0&id=585b3fae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b3fae",
  null
  
)

export default component.exports